/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * --- REWRITE SUMMARY (V53 - Pass Status Hook) ---
 * - MISSION: To update the hook to consume and return the new `passStatus`
 * state from the refactored UserProvider.
 *
 * - THE BUG: The previous version of the hook did not provide a way for
 * components to know if a user had an active Indikin Pass.
 *
 * - THE DEFINITIVE FIX:
 * 1.  The hook's return statement, which pulls directly from the context
 * value, now implicitly includes `passStatus`. No structural change is
 * needed here because the provider was already updated to include it. This
 * file rewrite serves to confirm and document that `passStatus` is now an
 * official part of the returned user context object.
 *
 * - RESULT: This change completes the state management phase. Any protected
 * component can now call `useUser()` and destructure `passStatus` to make
 * decisions about content access, such as showing a "Buy a Pass" modal
 * instead of a video player.
 */
import { useContext } from 'react';
import { UserContext } from '@/context/user.context.js';

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    // This error is crucial for debugging. It ensures developers don't try
    // to access user data outside of the provider's scope.
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
